import { Button, Form, Modal, Select } from 'antd'
import React from 'react'
import { usePostInsuranceSubscription } from '../hooks/insuredCompany/insuredCompany'

const SubscriptionModal = ({openModal, closeModal, paymentMethods, subscriptions}) => {
  const [form] = Form.useForm()

  const { mutate: postAction, isLoading: loading } = usePostInsuranceSubscription()
  const onSubmitEdit = (values) => {
    // 3aaeabe7-27a9-4a2a-a37b-0d28d60530c2
    const payload = {
      paymentMethodId: values.paymentMethodId,
      subscriptionId:  values.subscriptionId,
    }
    postAction(values)
    closeModal(false)
  }
  return (
    <Modal
      title="New Subscription"
      onCancel={() => closeModal(false)}
      open={openModal}
      footer={false}
    >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item name="subscriptionId" label="subscriptionId" required>
            <Select 
              size='large' 
              placeholder='Select Subscription Type' 
            >
              {subscriptions?.map((e)=>(
                <Select.Option key={e.id} value={e.id}>{e.title}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="paymentMethodId" label="paymentMethodId" required>
            <Select 
              size='large' 
              placeholder='Select Payment  Method' 
            >
              {paymentMethods?.map((e)=>(
                <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={() => closeModal(false)} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={loading} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
    </Modal>
  )
}

export default SubscriptionModal